.icon {
    object-fit: contain;
}
